import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class MathService {
    // Arrondit la valeur passée en paramètre
    roundedVal(val: number | string | null | undefined): number {
        if (val === null || val === undefined) {
            return 0;
        }
        const parsedValue = typeof val === 'string' ? parseFloat(val) : val;
        if (isNaN(parsedValue)) {
            return 0; // gére les cas où `val` n'est pas convertible en nombre (rare)
        }
        return Math.round(parsedValue * 100) / 100;
    }

    // Renvoie le total des valeurs paasées en paramètre
    getTotal(values: number[]) {
        let iterator = values.length;
        let total = 0;
        while (iterator > 0) {
            iterator--;
            total += this.roundedVal(values[iterator]);
        }
        return (total);
    }
}
